import slideAi from "../assets/slide-ai.png";
import slideClm from "../assets/slide-clm.png";
import slideConsulting from "../assets/slide-consulting.png";
import slideHero from "../assets/slide-hero.png";

export const heroSlides = [
  {
    id: "s1",
    background: slideHero,
    title: "Transforming Businesses into",
    titleHighlight: "Intelligent Digital Enterprises",
    subtitle:
      "From cloud-native platforms to AI-driven products, we empower businesses across the UK, US, and India with innovative, scalable, and intelligent technology solutions",
    showCtas: true,
  },
  {
    id: "s2",
    background: slideAi,
    title: "Delivering Innovative AI Solutions for Your Success",
    subtitle:
      "Empowering organizations with AI solutions that automate processes, enhance decision-making, and drive digital transformation through intelligent, scalable technologies.",
    showCtas: false,
  },
  {
    id: "s3",
    background: slideClm,
    title: "Contract Lifecycle Management (CLM)",
    subtitle:
      "An AI-powered, cloud-based contract management solution that streamlines the entire contract lifecycle. Automate workflows, improve compliance, reduce operational costs, and gain actionable insights to enhance efficiency across legal, sales, procurement, and HR teams.",
    subtitleColor: "primary" as const,
    showCtas: false,
  },
  {
    id: "s4",
    background: slideConsulting,
    title: "Digital Consulting",
    subtitle:
      "Transform business challenges into growth opportunities through strategic digital solutions, process optimization, and technology-driven innovation.",
    showCtas: false,
  },
];

export const whatWeDoCards: Array<{
  title: string;
  items: string[];
  path: string;
  external?: boolean;
}> = [
  {
    title: "Sundeus CLM",
    items: ["Contract Management", "Compliance", "Workflows"],
    path: "/contract-management",
  },
  {
    title: "Sundeus AI",
    items: ["GenAI Apps", "AI Assistants", "Automation"],
    path: "https://sundeus.ai",
    external: true,
  },
  {
    title: "Digital Consulting",
    items: ["Digital Transformation", "Product Engineering", "Cloud & Modernization"],
    path: "/offering",
  },
];

export const technologyServices = [
  {
    title: "AI & Machine Learning",
    description:
      "Leverage predictive analytics, NLP, and computer vision to unlock insights from your data. Our AI solutions automate decision-making and drive intelligent business outcomes.",
    path: "/offering",
  },
  {
    title: "UI/UX Design",
    description:
      "Create intuitive, beautiful digital experiences that users love. Our design-first approach combines user research with stunning visual design to deliver products that convert.",
    path: "/offering",
  },
  {
    title: "Enterprise Architecture",
    description:
      "Modernize legacy systems and design future-proof architectures. We help enterprises navigate complex technology landscapes with TOGAF-aligned architecture frameworks.",
    path: "/offering",
  },
  {
    title: "Cloud-Native Platforms",
    description:
      "Build scalable, resilient cloud infrastructure on AWS, Azure, and GCP. We design microservices architectures that grow with your business, ensuring 99.9% uptime and seamless deployments.",
    path: "/offering",
  },
  {
    title: "Web & Mobile App",
    description:
      "We build intelligent web and mobile applications powered by AI, delivering seamless user experiences, scalable performance, and data-driven automation to help businesses innovate and grow.",
    path: "/offering",
  },
  {
    title: "Enterprise Applications",
    description:
      "Empowering businesses with SAP solutions that streamline operations, enhance productivity, and drive digital transformation through implementation, integration, customization, migration, and support.",
    path: "/offering",
  },
];

export const clmFeatures = [
  "Smart Initiation & Intelligent Contract Authoring",
  "Risk Mitigation & capability to enable AI driven analytics",
  "One Touch Approvals , Review & Electronic Signatures",
  "Configurable Alerts and Notifications",
  "Version Control & Standard Clause Library Management",
  "Intutive & Smart User Interface",
];

export const stats = [
  { value: "3", label: "Global Offices" },
  { value: "150+", label: "Enterprise Clients" },
  { value: "500+", label: "Projects Delivered" },
  { value: "200+", label: "Team Members" },
];

export const aboutCopy = {
  label: "ABOUT SUNDEUS TECHNOLOGY",
  title: "Built by Innovators , Driven by Impact.",
  body: "Sundeus Technology is built by a team of technologists, product thinkers, and innovators who believe in making technology work for people and progress. With a global delivery model and agile mindset, we help startups and enterprises unlock growth through smart digital solutions. Operating across the UK, US, and India, our cross-functional teams bring together the best of cloud architecture, AI engineering, and enterprise design to deliver solutions that create measurable business impact.",
  visionTitle: "Our Vision",
  visionBody:
    "To be a trusted partner in building AI-driven, digitally empowered businesses that shape the future of work, life, & technology. We strive to enable organizations to innovate with confidence, harness the power of emerging technologies, and create sustainable growth.",
};

export const footerContent = {
  services: [
    { label: "Cloud Platforms", path: "/offering" },
    { label: "AI & Machine learning", path: "/offering" },
    { label: "Enterprise Architerature", path: "/offering" },
    { label: "UI/UX Design", path: "/offering" },
  ],
  company: [
    { label: "About Us", path: "/about" },
    { label: "Careers", path: "/career" },
    { label: "Our Team", path: "/about" },
    { label: "Contact", path: "/#contact" },
  ],
  solutions: [
    { label: "Contract Management", path: "/contract-management" },
    { label: "Cloud Migration", path: "/offering" },
    { label: "Digital Transformation", path: "/offering" },
    { label: "Data Analytics", path: "/offering" },
  ],
  offices: [
    "71-75 Shelton Street London, UK",
    "835, B2, SPAZE ITECH Park, Sector 49, Gurugram (NCR)",
    "909, Gera Imperium Rise, Hinjewadi Phase 2, Pune (MH)",
  ],
};
